export class MapaAn {
    constructor() {}
    commonStep = 'stepper.form.commun.mapa.step';
    step = 'stepper.form.mapa_an.step';

  }
